// staff-app/src/router/index.js

import { createRouter, createWebHistory } from "vue-router";

function cleanQueryValue(value) {
  if (Array.isArray(value)) return String(value[0] || "").trim();
  return String(value || "").trim();
}

const routes = [
  {
    path: "/",
    redirect: "/login",
  },

  {
    path: "/login",
    name: "StaffLogin",
    component: () => import("@/views/staff/StaffLogin.vue"),
  },

  {
    path: "/staff-login",
    redirect: "/login",
  },

  {
    path: "/rota",
    name: "StaffRotaPortal",
    component: () => import("@/views/staff/StaffRotaPortalView.vue"),
  },

  {
    path: "/training",
    name: "StaffTraining",
    component: () => import("@/views/staff/StaffTrainingView.vue"),
    props: (route) => ({
      venueId: cleanQueryValue(route.query.venueId),
      staffId: cleanQueryValue(route.query.staffId),
      staffName: cleanQueryValue(route.query.staffName),
      staffEmail: cleanQueryValue(route.query.staffEmail),
    }),
  },

  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export default router;